import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from './decorator/dropdown';

const propTypes = {
	transformToDropdown: PropTypes.bool,
	activateBreakpoint: PropTypes.number,
	children: PropTypes.oneOfType([
		PropTypes.element,
		PropTypes.array
	]),
	filters: PropTypes.array
};

const defaultProps = {
	transformToDropdown: false,
	activateBreakpoint: 1440
};

// This HOC added to wrapped component dropdown functionality
// when screen less this.activateBreakpoint and props.transformToDropdown = true
function ViewMode(SwitchControlComponent) {
	class HOC extends React.Component {
		constructor(props) {
			super(props);

			this.state = {
				shouldShowDropdown: false
			};

			this.handleResize = this.handleResize.bind(this);
		}

		componentDidMount() {
			this.handleResize();
			window.addEventListener('resize', this.handleResize);
		}

		componentWillUnmount() {
			window.removeEventListener('resize', this.handleResize);
		}

		getPlaceholder() {
			// single select
			if (this.props.children) {
				return this.props.children.reduce((acc, entity) => {
					if (entity.props.className.indexOf('active') > -1) {
						acc.push(entity.props.value);
					}
					return acc;
				}, []);
			}

			// multi select
			if (this.props.filters) {
				return this.props.filters
					.filter(entity => entity.active)
					.map(entity => entity.placeholder);
			}
		}

		render() {
			if (this.state.shouldShowDropdown && this.props.transformToDropdown) {
				const placeholder = this.getPlaceholder();
				return <Dropdown placeholder={placeholder}><SwitchControlComponent {...this.props} /></Dropdown>;
			}

			return <SwitchControlComponent {...this.props} />;
		}

		handleResize() {
			const windowWidth = window.innerWidth;

			this.setState({
				shouldShowDropdown: windowWidth <= this.props.activateBreakpoint
			});
		}
	}

	HOC.propTypes = propTypes;
	HOC.defaultProps = defaultProps;

	return HOC;
}

export default ViewMode;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/switch-control/hoc/view.js